import { rmmApp } from "../views/services/components/httpvariables";
var admin = [
  {
    _tag: 'CSidebarNavItem',
    name: 'FRP Accounts',
    to: '/setting/frp-accounts',
  }
];
// if (rmmApp === true) {
//   admin.push(
//     {
//       _tag: 'CSidebarNavItem',
//       name: 'Mobile apps control',
//       to: '/setting/app-visibility',
//     })
// };

let carouselSetting = [];
if (localStorage.getItem('role') === "admin" || localStorage.getItem('role') === "retailer") {
    carouselSetting = [
      {
        _tag: 'CSidebarNavItem',
        name: 'Slider',
        to: '/carousel',
        icon: 'cil-image-plus',
      }
    ]
}

// super admin menu preparation
const adminTitle = localStorage.getItem('is_super') === "true" ? "Super Admin" : "Admin";
const adminMenu = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Retailer',
    to: '/user-management/retailer',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Distributor',
    to: '/user-management/financer',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Super Distributor',
    to: '/user-management/distributor',
  }
];

if (localStorage.getItem('is_super') === "true") {
  adminMenu.push({
    _tag: 'CSidebarNavItem',
    name: 'Admin',
    to: '/user-management/admin-users',
  });
}

if (localStorage.getItem('is_super') === "false" && localStorage.getItem('role') === "admin" && localStorage.getItem('userType') !== "sub-admin") {
  adminMenu.push({
    _tag: 'CSidebarNavItem',
    name: 'Sub Admin',
    to: '/sub-admin',
  });
}

// Report menu
let reportsMenu = [
  {
    _tag: 'CSidebarNavTitle',
    _children: ['Reports']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Report',
    route: '/report',
    icon: 'cil-list',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Key Distribution',
        to: '/report/key-distribution',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Daily Activation',
        to: '/report/tertiary',
      }
    ],
  },
];

if (localStorage.getItem('role') ==  'admin' && localStorage.getItem('userType') == 'sub-admin') {
  reportsMenu = [];
}

const reportsRetailerMenu = [
  {
    _tag: 'CSidebarNavTitle',
    _children: ['Reports']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Report',
    route: '/report',
    icon: 'cil-list',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Daily Activation',
        to: '/report/tertiary',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Package History',
        to: '/user-management/user/packagehistory',
      }
    ],
  },
];

// settings menu
const settingsMenu = [
  {
    _tag: 'CSidebarNavItem',
    name: 'FRP Accounts',
    to: '/setting/frp-accounts',
  },
];

if (localStorage.getItem('type') === "complete" || localStorage.getItem('type') === "undefined" || localStorage.getItem('type') === "lockonly") {
  settingsMenu.push({
    _tag: 'CSidebarNavItem',
    name: 'Message Setting',
    to: '/setting/message-setting',
  });
}

const navigation = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['User Management']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: adminTitle,
    route: '/user-management',
    icon: 'cil-puzzle',
    _children: adminMenu,
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['Settings']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Settings',
    route: '/setting',
    icon: 'cil-puzzle',
    _children: admin,
  },
  ...carouselSetting,
  ...reportsMenu
]

const retailerSettings =  localStorage.getItem('type') !== "tv" ? [
  {
    _tag: 'CSidebarNavTitle',
    _children: ['Settings']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Settings',
    route: '/setting',
    icon: 'cil-settings',
    _children: settingsMenu,
  },
] : [];

const retailer = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['User Management']
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Users',
    to: '/user-management/user',
    icon: 'cil-user',
  },
  ...retailerSettings,
  ...reportsRetailerMenu,
  ...carouselSetting
]
const financer = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['User Management']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Distributor',
    route: '/user-management',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Retailer',
        to: '/user-management/financer-retailer',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Sales Officer',
        to: '/sales-officer',
      }
    ],
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['Settings']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Settings',
    route: '/setting',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'FRP Accounts',
        to: '/setting/frp-accounts',
      },
      // {
      //   _tag: 'CSidebarNavItem',
      //   name: 'Message Setting',
      //   to: '/setting/message-setting',
      // },
    ],
  },
  ...reportsMenu
]

const distributor = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavTitle',
    _children: ['User Management']
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Super Distributor',
    route: '/user-management',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Distributor',
        to: '/user-management/distributor-financer',
      }
    ],
  },
  ...reportsMenu
];

const salesOfficerMenu = [
  {
    _tag: 'CSidebarNavTitle',
    _children: ['Sales Officer']
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Retailer',
    to: '/user-management/sales-officer-retailer',
    icon: 'cil-user',
  },
]

export { navigation, retailer, financer, distributor, salesOfficerMenu }

